import {
  Component,
  OnInit,
  Input,
  HostBinding,
  ElementRef,
  ChangeDetectionStrategy
} from '@angular/core';

@Component({
  selector:
    // tslint:disable-next-line: component-selector
    'button[sc-button], button[sc-stroked-button], button[sc-basic-button], a[sc-button], a[sc-stroked-button]',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ButtonComponent implements OnInit {
  @Input() color = 'primary';
  @HostBinding('class.checked') @Input() checked: boolean;
  @HostBinding('class.disabled') @Input() disabled: boolean;
  @HostBinding('attr.type') @Input() type = 'button';

  @HostBinding('attr.data-color')
  get hostAttrColor(): string {
    const _el = this.el.nativeElement;
    if (_el.tagName !== 'A') {
      return this.color;
    } else {
      return _el.hasAttribute('color') ? this.color : undefined;
    }
  }

  constructor(private el: ElementRef) {}

  ngOnInit() {}
}
